import { ContentService, ImageService, ObserverService } from '@DavisDigital/davisdigitalfrontend.module';

import { ContentModuleTypes } from '../interfaces';

class ImageCaptionModalController {
	
	public image;
	public originalCaption;
	
	// @ngInject
	constructor(
		public imageService		: ImageService,
		public contentService	: ContentService, 
		public observerService	: ObserverService,
		public ModalService
	){}
	
	public $onInit = () => {
		this.originalCaption = this.image.caption;
	}
	
	
	public close = (save) =>{
		
		if(!save){
			this.image.caption = this.originalCaption;
		}
		
		var modalToCloseIndex = 0;
		if(this.ModalService.openModals.length === 2){
			modalToCloseIndex = 1;
		}
		//This is a workaround ModalService technically does not support more than one modal
		this.ModalService.openModals[modalToCloseIndex].modal.element.modal('hide');
		this.ModalService.openModals.splice(modalToCloseIndex, 1);
	}
	
}

class ImageCaptionModal {
	
	public restrict: string = 'E';
	public scope: boolean = true;
	
	public bindToController: any = {
		image: '='
	};

	public controller = ImageCaptionModalController;
	public controllerAs = 'imageCaptionModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/image-caption-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { ImageCaptionModal };
